
<component :is="component" :class="componentClasses">

  <!-- buttons leading a-selects -->
  <template v-if="topLevel">
    <template v-if="selectedChildConfig">
      <p v-if="selectedChildConfig.displayName !== 'Hyperlink'">
        {{selectedChildConfig.displayName}}
      </p>
    </template>

    <!-- buttons for links creations -->
    <row v-else class="quickmenu-links">
      <column v-for="(childConfig, index) in builderConfig.children" :key="`${level}-${index}`" class="link">
        <button type="button" class="btn clear-to-blue" @click="configSelected(childConfig)">
          <icon :class="StringHelper.toDash(childConfig.displayName)"></icon>
          {{childConfig.displayName}}
        </button>
      </column>
    </row>
  </template>

  <template v-else-if="hasInstanceObjectSelectChild">
    <icon class="arrow-fat right" color="Blue"></icon>
    <bookmark-link-builder-instance-object-selector
      :builder-config="builderConfig"
      :level="level"
      :is-editing="isEditing"
    />
  </template>

  <template v-else-if="hasInputChild">
      <label for="link-address">
        Link Address
        <help-tooltip v-if="isEditing" :text="textInputHelpText"></help-tooltip>
      </label>
      <input
        v-model="textInput"
        type="text"
        id="link-address"
        class="form-control"
        :class="{'is-invalid': textInputInvalid}"
        :disabled="!isEditing"
      >

    <div class="invalid-feedback">
      does not appear to be a valid URL
    </div>
  </template>

  <template v-else-if="builderConfig.children">
      <icon class="arrow-fat right" color="Blue"></icon>
      <a-select
        :options="childrenSelectOptions"
        bind-by-object
        :value="childrenSelectValue"
        @input="configSelected"
        :disabled="!isEditing"
      />
  </template>
</component>
